import { InjectionToken } from '@angular/core';
import { FilterSelectorBaseService } from '@shared/services/filter-selector-base.service';

export const FilterSelectorServiceInjectionToken = new InjectionToken<FilterSelectorBaseService<any>>('FILTER_SELECTOR_SERVICE_TOKEN');
export const FilterSelectorInjectionToken = new InjectionToken<string>('selectorToken');
